<template>
  <div class="editor-check-container">
    <div
      class="check-content"
      v-if="!isChecked && isCanCheck"
    >
      <router-link
        :to="alterUrl"
        target="_blank"
      >
        <i class="icon jlxk-editor-check" />智能审校
      </router-link>
      <p>
        点击【智能审校】按钮开始校对
      </p>
    </div>
    <div
      v-if="isChecked"
      class="check-content"
    >
      <div class="total">
        <router-link
          v-if="isCanCheck"
          :to="alterUrl"
          target="_blank"
        >
          <i class="icon icon-jgsd-review-alter" />修改
        </router-link>
        <span
          class="check-total"
        >共 <em>{{ total }}</em> 个检查项发现可疑内容</span>
        <router-link
          v-if="isShowReport"
          class="toReport"
          title="单篇审读报告"
          :to="toReportUrl"
          target="_blank"
        >
          <i class="icon icon-jgsd-epaper-report" />
        </router-link>
        <i
          class="icon refresh"
          title="数据刷新"
          @click="getReviewResult"
        />
      </div>
      <ul class="review-result-ul">
        <template v-if="!isEmpty">
          <li
            v-for="(item, index) in tableData"
            :key="index"
            :class="{ active: item.count > 0 }"
          >
            {{ item.name
            }}<span>{{ item.count > 0 ? "发现可疑内容" : "未见异常" }}</span>
          </li>
        </template>
        <li
          v-else
          class="empty"
        >
          {{ empty }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import APIS from '@apis/jlxk'
import { inspectTypeArr } from '@views/jgsd/report/data/type.js'
export default {
  name: 'Check',
  props: {
    id: {
      type: String,
      default: ''
    },
    system: {
      type: String,
      default: () => '0'
    },
    layoutId: {
      type: String,
      default: ''
    },
    // 已通过的稿件不能修改
    isShowOperate: {
      type: Boolean,
      default: true
    },
    isShowReport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isChecked: false,
      tableData: [],
      empty: ''
    }
  },
  computed: {
    currentIndex() {
      return this.$store.state.currentIndex
    },
    isInterNetDoc() {
      return this.system === '1'
    },
    alterPath() {
      return this.isInterNetDoc ? '/jgsd/review/edit' : '/jgsd/editor'
    },
    alterUrl() {
      const param = this.layoutId ? '&layoutId=' + this.layoutId : ''
      return (
        `${this.alterPath}?modelId=${this.currentIndex}&id=${this.id}&check=true` +
        param
      )
    },
    isCanCheck() {
      return auth_review_enabled && this.isShowOperate
    },
    toReportUrl() {
      return `/jgsd/review/report/article?modelId=${this.currentIndex}&id=${this.id}`
    },
    total() {
      return this.tableData.filter(item => item.count > 0).length || 0
    },
    isEmpty() {
      return this.total === 0
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 审核结果列表
    async getReviewResult() {
      this.tableData = []
      this.empty = ' '
      let { status, data } = await APIS.postReviewResult({
        params: { docId: this.id }
      })
      this.isChecked = status === 0
      if (status === 0 && data) {
        if (data.length !== 0) {
          this.tableData = inspectTypeArr.map(item => {
            let isHasResult = data.filter(i => i.inspectType === item.name)
            return {
              name: item.name,
              count: isHasResult.length || 0
            }
          })
        } else {
          this.empty = '无错误'
        }
      }
    }
  },
  watch: {
    id: {
      handler(newVal) {
        if (!newVal) {
          return false
        }
        this.getReviewResult()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-check-container {
  margin-top: 15px;
  .check-content {
    padding: 15px;
    background: #f5f5f5;
    a {
      display: flex;
      width: 135px;
      height: 28px;
      align-items: center;
      justify-content: center;
      padding: 0;
      background: rgba(68, 151, 236, 0.2);
      border-radius: 3px;
      font-size: 13px;
      font-family: "founder_youhei_508R";
      color: #4497ec;
      text-decoration: none;
      i {
        margin-right: 10px;
      }
    }
    p {
      margin-top: 9px;
      font-size: 12px;
      color: #a9a9a9;
    }
    .total {
      position: relative;
      display: flex;
      align-items: center;
      a {
        width: 100px;
        margin-right: 2px;
      }
      .toReport {
        width: auto;
        margin: 0;
        background: transparent;
        position: absolute;
        right: 25px;
      }
      i.refresh {
        position: absolute;
        right: 5px;
        cursor: pointer;
      }
    }
    .check-total {
      margin-left: 10px;
      font-size: 12px;
      color: #666;
      em {
        color: #4497ec;
        font-style: normal;
      }
    }
  }
  ul.review-result-ul {
    margin-top: 10px;
    border: 1px solid #dcdcdc;
    border-width: 1px 1px 0 1px;
    // max-height: 225px;
    // overflow-y: auto;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      padding: 0 20px;
      background-color: #fff;
      border-bottom: 1px solid #dcdcdc;
      font-size: 12px;
      &.active {
        color: #e30e0e;
      }
      &.empty {
        color: #999;
        justify-content: center;
      }
    }
  }
}
</style>
